<template>
    <ubi-page-container>
        <router-link :to="{ name: 'selection-vo' }">
            <el-link class="mb-3">{{ $t(goBackTitle) }}</el-link>
        </router-link>

      <!-- DEBUT MODAL-->
      <transition name="modal" v-if="showModal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <h2 class="modal-header">
                <slot name="header">
                  {{ $t("posts.view.contacterVendeur") }}
                </slot>
              </h2>
              <div class="modal-body">
                <div class="text-center" style="font-size: 1rem">
                  <div v-if="post.telephone_a_afficher">
                    <div>Vous pouvez contacter le portail par téléphone</div>
                    <div style="color: #184A56; font-weight: bold; padding: 0.5em;">{{ post.telephone_a_afficher }}</div>
                    <div>Ou</div>
                  </div>
                  <div style="padding: 0.5em;">Vous pouvez contacter le portail par email</div>
                </div>
                <slot name="body">
                  {{ $t("posts.view.sendByEmailRecipient") }}
                  <el-input :value="destinataireEmail" disabled="disabled"></el-input>
                  <br />
                  <br />
                  {{ $t("posts.view.emailReplyTo") }}
                  <el-input v-model="replyToEmail"></el-input>
                  <span v-if="invalidEmail" style="color: red">{{ $t("validator.validEmail") }}</span>
                  <br />
                  <br />
                  {{ $t("posts.view.sendByEmailMessage") }}
                  <el-input type="textarea" :rows="10" v-model="commentaireEmail"></el-input>
                  <div v-if="getMarchandUrl(post)">
                    <br />
                    {{ $t("posts.view.portalLink") }}
                    <div class="el-input"><input type="text" class="el-input__inner" :value="getMarchandUrl(post)" disabled="disabled" style="color: #0ab1bf;" /></div>
                  </div>
                </slot>
              </div>
              <div class="modal-footer">
                <slot name="footer">
                  <el-button @click="showModal = false" class="inline">{{ $t("posts.view.cancel") }}</el-button>
                  <el-button type="primary" class="inline" @click="sendByEmail" v-loading="loading">{{ $t("posts.view.send") }}</el-button>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!--FIN MODAL-->

        <div class="divPanel" v-if="post">
            <div>
                <div>
                    <el-row>
                        <el-col :lg="24">
                            <h1 v-if="post.emission.codeName === 'ENTRE_MARCHANDS_AUTO_IMPORT'">{{ $t("posts.view.selectionVoMarchand") }} : {{ getMarchandNom(post) }}</h1>
                            <h1 v-else-if="post.emission.codeName">{{ $t("posts.view.selectionVoMarchand") }} : {{ post.emission.codeName }}</h1>
                            <h1 v-else>{{ $t('posts.view.selectionVo') }}</h1>
                        </el-col>
                    </el-row>
                </div>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="14">
                        <div>
                            <div id="blockPrincipal">
                                <el-image id="imageAgrandit" style="max-width: 90%;" v-if="post.photoPrincipale != null" :src="post.photoPrincipale.url" fit="contain"></el-image>
                                <div v-else><ubi-icon class="no-photo" name="camera" size='250'/></div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="9">
                        <div class="text-center" style="margin-top: 1%">
                            <div>
                              <h2>{{ post.marque }} {{ post.modele }}</h2>
                              <h3>{{ post.version }} - {{ post.puissance_reelle }} ch</h3>
                              <h4>{{ post.millesime }} - {{ post.kilometrage }} km - {{ post.boite_de_vitesse }}</h4>
                              <div v-if="post.prix_marchand">
                                <h3>
                                  <span class="price">{{ post.prix }} {{ post.devise_iso_4217 }}</span>
                                  <span class="priceDetails"> ({{ $t('posts.view.pricePublic') }})</span>
                                </h3>
                                <h3>
                                  <span class="price">{{ post.prix_marchand }} {{ post.devise_iso_4217 }}</span>
                                  <span class="priceDetails"> ({{ $t('posts.view.priceDealer') }})</span>
                                </h3>
                              </div>
                              <div v-else>
                                <h3><span class="price">{{ post.prix }} {{ post.devise_iso_4217 }}</span></h3>
                              </div>
                              <h4>{{ post.ville }}</h4>
                            </div>
                            <div>
                              <el-button
                                  type="primary"
                                  class="inline"
                                  @click="afficherModal"
                                  v-loading="loading"
                              >{{ $t("posts.view.contacter") }}
                              </el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="14" id="blockPhotosImmoVo">
                        <div class="demo-image__placeholder" >
                            <!--ICI ON PARCOURS TOUTES LES PHOTOS POUR LES AFFICHER EN MINATURE SOUS LA PHOTO PRINCIPALE.-->
                            <a v-for="photo in post.photos" :key="photo.id" @click="agrandirPhoto(photo.url)">
                                <el-image :src='photo.url' class="photosAffichette"></el-image>
                            </a>
                        </div>
                    </el-col>
                </el-row>
              <el-row style="margin-top: 15px;">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="14">
                  <el-row class="text-center">
                    <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="5" v-if="post.camera_recul">
                      <div class="iconAvantage"><img :src="require(`@/assets/camera.svg`)" height="30px" alt="camera" /></div>
                      <div>{{ $labels.camera_recul }}</div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="5" v-if="post.premiere_main">
                      <div class="iconAvantage"><img :src="require(`@/assets/volant.png`)" height="30px" alt="firsthand" /></div>
                      <div>{{ $labels.premiere_main }}</div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="5" v-if="post.classe_critair">
                      <div class="iconAvantage"><img :src="require(`@/assets/critair.svg`)" height="30px" alt="critair" /></div>
                      <div>{{ $labels.classe_critair }} {{ post.classe_critair }}</div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="5" v-if="post.garantie_libelle && (post.garantie_libelle.toUpperCase() == 'CONSTRUCTEUR')">
                      <div class="iconAvantage"><img :src="require(`@/assets/garantie.svg`)" height="30px" alt="guarantee" /></div>
                      <div>{{ $t("posts.view.sousGarantieConstructeur") }}</div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="5">
                  <h4>Caractéristiques</h4>
                  <div v-if="post.millesime"><span class="libelleEquipements">{{ $labels.millesime }} :</span> {{ post.millesime }}</div>
                  <div v-if="post.pays"><span class="libelleEquipements">{{ $labels.pays }} :</span> {{ post.pays }}</div>
                  <div v-if="post.mise_en_circulation"><span class="libelleEquipements">{{ $labels.mise_en_circulation }} :</span> {{ post.mise_en_circulation }}</div>
                  <div v-if="post.controle_technique"><span class="libelleEquipements">{{ $labels.controle_technique }} :</span> {{ post.controle_technique }}</div>
                  <div v-if="post.premiere_main"><span class="libelleEquipements">{{ $labels.premiere_main }} :</span> {{ post.premiere_main }}</div>
                  <div v-if="post.kilometrage"><span class="libelleEquipements">{{ $labels.kilometrage }} :</span> {{ post.kilometrage }} km</div>
                  <div v-if="post.energie"><span class="libelleEquipements">{{ $labels.energie }} :</span> {{ post.energie }}</div>
                  <div v-if="post.boite_de_vitesse"><span class="libelleEquipements">{{ $labels.boite_de_vitesse }} :</span> {{ post.boite_de_vitesse }}</div>
                  <div v-if="post.couleur"><span class="libelleEquipements">{{ $labels.couleur }} :</span> {{ post.couleur }}</div>
                  <div v-if="post.nb_portes"><span class="libelleEquipements">{{ $labels.nb_portes }} :</span> {{ post.nb_portes }}</div>
                  <div v-if="post.nb_places"><span class="libelleEquipements">{{ $labels.nb_places }} :</span> {{ post.nb_places }}</div>
                  <div v-if="post.longueur"><span class="libelleEquipements">{{ $labels.longueur }} :</span> {{ post.longueur }} m</div>
                  <div v-if="post.volume_coffre"><span class="libelleEquipements">{{ $labels.volume_coffre }} :</span> {{ post.volume_coffre }} litres</div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="4">
                  <h4>Puissance du véhicule</h4>
                  <div v-if="post.puissance_fiscale"><span class="libelleEquipements">{{ $labels.puissance_fiscale }} :</span> {{ post.puissance_fiscale }} CV</div>
                  <div v-if="post.puissance_reelle"><span class="libelleEquipements">{{ $labels.puissance_reelle }} :</span> {{ post.puissance_reelle }} CH</div>
                  <div v-if="post.consommation_mixte"><span class="libelleEquipements">{{ $labels.consommation_mixte }} :</span> {{ post.consommation_mixte }} litres/100km</div>
                  <div v-if="post.norme_euro_emission"><span class="libelleEquipements">{{ $labels.norme_euro_emission }} :</span> {{ post.norme_euro_emission }}</div>
                  <div v-if="post.classe_critair"><span class="libelleEquipements">{{ $labels.classe_critair }} :</span> {{ post.classe_critair }}</div>
                  <div v-if="post.emission_co2"><span class="libelleEquipements">{{ $labels.emission_co2 }} :</span> {{ post.emission_co2 }} g/km</div>
                </el-col>
              </el-row>
            </div>
        </div>
    </ubi-page-container>
</template>

<script>
import { PostMixin } from '../posts'
import UbiPanel from '../../../components/Panel'
import ElButton from '../../../components/Button'
import { sendEmail } from '../../../services/email'
import { mapState } from 'vuex'

export default {
  name: 'PostViewSelectionVo',
  components: { ElButton, UbiPanel },
  inject: ['browserContext'],
  mixins: [PostMixin],
  data () {
    return {
      loading: false,
      loadingButton: true,
      photoAgrandit: null,
      photoPrincipale: null,
      invalidEmail: false,
      post: null,
      labelsLoaded: false,
      showModal: false,
      commentaireEmail: null,
      replyToEmail: null,
      destinataireEmail: null,
      marchands: {
        ENTRE_MARCHANDS_AUTO_IMPORT: { name: 'Entre marchands auto', url: 'https://entre-marchands-auto.com/' }
      }
    }
  },
  computed: {
    ...mapState('posts', ['filter', 'results']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    universe () {
      return this.sitimmoUser.univers
    },
    goBackTitle () {
      return this.$t('posts.view.goBackTitleSelectionVo')
    },
    pageTitle () {
      return this.$t('posts.view.selectionVo')
    }
  },
  beforeMount () {
    this.$route.meta.title = this.pageTitle
  },
  created () {
    // si on fait un changement de langue, les labels peuvent ne pas avoir le temps de
    // se charger. Le code suivant attend un peu avant d'afficher les components si besoin.
    if (this.$labels === undefined) {
      setTimeout(() => {
        this.labelsLoaded = true
      }, 4000)
    } else {
      this.labelsLoaded = true
    }
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.sitimmoUser.id)
    },
    getMarchandNom (post) {
      let marchandName = post.emission.codeName
      if (this.marchands[post.emission.codeName]) {
        marchandName = this.marchands[post.emission.codeName].name
      }
      return marchandName
    },
    getMarchandUrl (post) {
      let marchandUrl = ''
      if (this.marchands[post.emission.codeName]) {
        marchandUrl = this.marchands[post.emission.codeName].url
      }
      return marchandUrl
    },
    replaceApostrophes (text) {
      return text.replace(`'`, ` `)
    },
    agrandirPhoto (picture) {
      document.getElementById('imageAgrandit').src = picture
      window.scrollTo(0, 0)
    },
    displayBoolean (value) {
      if (value === true) {
        return this.$t('general.yes')
      }
      if (value === false) {
        return this.$t('general.no')
      }
      return null
    },
    afficherModal () {
      this.showModal = true
      this.destinataireEmail = this.post.email_a_afficher
      this.replyToEmail = this.user.email
      this.commentaireEmail = this.$t('posts.view.selectionVoEmailComment', { postRef: this.post.reference }) + '\n' +
          this.post.marque + ' ' + this.post.modele + '\n' +
          this.post.version + ' ' + this.post.couleur + '\n' +
          this.post.prixDisplay + ' ' + this.post.millesime + '\n'
      if (this.post.kilometrage) {
        this.commentaireEmail += this.post.kilometrage + ' km\n'
      }
      if (this.post.puissance_reelle) {
        this.commentaireEmail += this.post.puissance_reelle + ' ch\n'
      }
    },
    async sendByEmail () {
      this.invalidEmail = !this.isValidEmail(this.replyToEmail)
      if (this.invalidEmail) {
        this.showModal = false
        return
      }
      const mailData = {
        to: this.destinataireEmail,
        replyTo: this.replyToEmail,
        subject: this.$t('posts.view.selectionVoEmailSubject', { postTitle: this.post.titre }),
        content: this.commentaireEmail
      }
      const response = await sendEmail(mailData)
      if (response.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        this.showModal = false
        return false
      }
      this.$message(response)
      this.loading = false
      this.invalidEmail = false
      this.showModal = false
      window.scrollTo(0, 0)
    },
    isValidEmail (email) {
      return /\S+@\S+\.\S+/.test(email)
    }
  }
}
</script>

<style>
    .price {
      font-size: 1.3em;
      color: #0ab1bf;
    }
    .priceDetails {
      color: black;
      font-size: 0.8em;
    }
    .divPanel {
        padding: 3%;
        background-color: white;
    }
    #blockPhotosImmoVo {
        display: inline-block;
    }
    #blockPrincipal {
        width: 100%;
        height: auto;
    }
    .photosAffichette {
        max-height: 70px;
        margin-right: 3px;
        max-width: 140px;
        overflow: visible;
        width: auto;
    }
    .photosAffichette img {
        height: 70px;
        max-width: 140px;
        width: auto;
    }
    .libelleEquipements {
      font-weight: bold;
    }
    .iconAvantage {
      display: inline-block;
      border-radius: 60px;
      box-shadow: 0 0 2px #888;
      padding: 0.5em 0.6em;
      margin-bottom: 0.5em;
    }
    /*DEBUT POPUP ENVOYER ANNONCE*/
    .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
    }

    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }

    .modal-container {
      width: 600px;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
      margin-top: 0;
      color: #42b983;
    }

    .modal-body {
      margin: 20px 0;
    }

    .modal-default-button {
      float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
      opacity: 0;
    }

    .modal-leave-active {
      opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }

    /*FIN POPUP ENVOYER ANNONCE*/
</style>
